import { Link } from "react-router-dom";
import { categories, hotSearches } from "@/mocks/gossip";

export default function PlazaAside() {
  return (
    <aside className="flex flex-col gap-6">
      <div className="rounded-lg border border-background-200 bg-background-100 p-5">
        <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <i className="ri-fire-line text-lg text-accent-600" aria-hidden="true"></i>
          热搜快照
        </h2>
        <ol className="mt-4 space-y-3">
          {hotSearches.slice(0, 6).map((item) => (
            <li key={item.id}>
              <Link to="/plaza" className="group flex items-start gap-3">
                <span
                  className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-bold ${
                    item.rank <= 3
                      ? "bg-accent-500 text-background-50"
                      : "bg-background-300/70 text-foreground-700"
                  }`}
                >
                  {item.rank}
                </span>
                <span className="min-w-0 text-sm leading-snug text-foreground-800 transition-colors group-hover:text-primary-700">
                  {item.title}
                </span>
              </Link>
            </li>
          ))}
        </ol>
      </div>

      <div className="rounded-lg border border-background-200 bg-background-50 p-5">
        <h2 className="font-heading text-base font-bold text-foreground-950">全部板块</h2>
        <ul className="mt-4 space-y-1">
          {categories.map((category) => (
            <li key={category.id}>
              <Link
                to={`/plaza?category=${category.id}`}
                className="flex items-center justify-between rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-800"
              >
                <span className="flex items-center gap-2">
                  <i className={`${category.icon} text-base`} aria-hidden="true"></i>
                  {category.name}
                </span>
                <span className="text-xs text-foreground-400">{category.count}</span>
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="rounded-lg border border-primary-200 bg-primary-100/60 p-5">
        <h2 className="font-heading text-base font-bold text-primary-900">有料没处说？</h2>
        <p className="mt-2 text-sm leading-relaxed text-foreground-700">
          看到值得跟进的公开线索，欢迎按页面底部邮箱投稿。附上可核实的链接，我们会安排核对。
        </p>
        <Link
          to="/#follow"
          className="mt-4 inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-primary-600 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
        >
          订阅蹲后续
          <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
        </Link>
      </div>
    </aside>
  );
}